import styled from 'styled-components';
import { createGlobalStyle } from "styled-components";

export const DBBannerCss = styled.div`
    background: ${props => props.bgImage ? `url(${props?.bgImage})` : "none"};
    width: 100%;
    min-height:100vh;
    background-size: cover;
    background-position: 100% 27%;
  
    h1{
        position: absolute;
        bottom: 100px;
        left: 50%;  
        font-size: 100px;
        color:  var(--cmn-white);  
        transform: translateX(-50%);
        width: 100%;
        margin-bottom: 0;
        font-family: var(--common-font);
        z-index: 99;
        @media (max-width: 991px){
            font-size: 60px;
            bottom: 60px;
        }
        @media (max-width: 767px){
            font-size: 30px;
            bottom: 60px;
        }
    }
    /* iframe {
        max-width: 480px;
        height: 350px;
        min-width: 610px; 
        width: 100%;
        overflow: hidden;
        margin-bottom: -3px;
    } */
    .become {
        position: absolute;
        left: 10%;
        top: 50%;
        padding: 10px 20px;
        background: rgb(30 69 116 / 70%);
        span {
        font-size: 50px;
        color:  var(--cmn-white);
    }
    }
     iframe {
        max-width: 130vw;
        height: 200%;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 99;
        width: 100%;
        transform: translate(-50%,-50%);  
}
`;



export const SectionOneCss = styled.div`
   
    display:flex;  
    align-items: center; 
    background: var(--grey);
    padding: 40px 0 0;
   
    .secondBlock_sectionOne {
        img {
            width:100%
        }
    } 

    .firstBlock_sectionOne { 
    width: 100%;
    .first-block { 
        text-align: center;
        max-width: 1220px;
        margin: 0 auto;
        h4 {
            font-size: 30px;
            @media (max-width: 767px){
                font-size: 24px
            }
          }
        font-family: var(--common-font);
        p {
            font-size: 17px;
        }
    } 
}

  .secondBlock_sectionOne {
    background: url("/images/sectionOneImage.png") no-repeat;
    width: 100%;
    display: block;
    line-height: 1;
    max-width: 600px;background-size: contain;
}

.secondBlock_sectionOne  iframe {
    max-width: 480px;
    height: 340px;
    min-width: 600px; 
    width: 100%;
    overflow: hidden;
    margin-bottom: -3px;
}

.first-block { 
            ul {
            padding: 0;
            list-style: none;
                li span {
                position: relative;
                padding-left: 17px;
                    :before {
                    content: "";
                    width: 6px;
                    height: 6px;
                    background:  var(--cmn-black);
                    position: absolute;
                    left: 0;
                    top: 4px;
                    border-radius: 50%;
                }
            }
        }
    }
      
`;

export const SectionTwoCss = styled.div`
    position: relative;    
        padding-top: 240px; 
        @media (max-width: 767px){
            padding-top: 200px;
        }
    ::before { 
        background: rgb(237,237,237);
        background: -moz-linear-gradient(175deg, rgba(237,237,237,1) 50%, rgba(255,255,255,0) 50%);
        background: -webkit-linear-gradient(175deg, rgba(237,237,237,1) 50%, rgba(255,255,255,0) 50%);
        background: linear-gradient(175deg, rgba(237,237,237,1) 50%, rgba(255,255,255,0) 50%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ededed",endColorstr="#ffffff",GradientType=1);
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 180px;
        z-index: 99;
        width: 100%; 
    }
    .section-two{
            @media (max-width: 991px){
                .row{
                    .col-md-4{
                        width: 100%;
                        &:nth-child(2){
                            margin: 40px 0;
                        }
                    }
                }
            }
        }
 
    .main-bx {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
        border-radius: 20px;
        padding: 20px;
        font-family: var(--common-font); 
        position: relative; 
        @media (max-width: 1280px){
            h2{
                font-size: 30px;
            } 
        }
        @media (max-width: 767px){
            h2{
                font-size:  26px;
            }
           
        }
        
          p, h3 {
            font-size: 17px;
            margin-bottom: 0;
          } 
            ul {
            padding: 0;
            list-style: none;
                li span {
                position: relative;
                padding-left: 17px;
                    :before {
                    content: "";
                    width: 6px;
                    height: 6px;
                    background:  var(--cmn-black);
                    position: absolute;
                    left: 0;
                    top: 4px;
                    border-radius: 50%;
                }
            }
        } 
       
    }
    .btn-primary.btn{
            margin-top: 30px;
        }
    .main-two {
        position: absolute;
        /* background: url(images/graydiant.jpg); */
        max-width: 600px;
        min-height: 300px;
        left: 16%;
        bottom: -190px;
        padding: 30px;
        background-size: cover;
        z-index: 99;
        h2 {
            font-size: 25px !important;
            font-weight: 500;
            font-weight: 600;
            margin-bottom: 20px;
            text-align: left;
        } 
    }

 
    .first_block_sectionTwo {
        text-align: left;
        font-size: 18px;
    }
    .animated-gradients  {
        height: 100%;
        overflow: hidden;
        width: 100%;
        z-index: -1;
        top: 0;
        position: absolute ;
        left: 0;
    }
    .animated-gradients svg.animated-gradients__svg {
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 0;
    }

`;

export const SectionThreeCss = styled.div`
/*     
    background: ${props => `url(${props.bgImg})`};
    background-size: cover; */
    /* min-height: 860px;  */
    /* .react-parallax:after {
        content: "";
        position: absolute;
        clip-path: polygon(36% 100%, 100% 89%, 100% 100%, 0 100%, 0 87%);  
        width: 100%;
        height: 100%;
        left: 0;
        background: #fff;
        z-index: 0;
        bottom: 0px;
    }
   */
    margin: 50px 0;
     img{
         width: 100%;
     }
    .firstContainer_sectionThird {
        margin-bottom: 30px;
    } 
 
    
`;

export const SectionFourCss = styled.div` 
    .sec-four {
        position: relative;
         z-index: 9;
        &:after {
        content: "";
        position: absolute;
        height: 100%;
        left: 50%;
        width: 100%; 
        /* background: rgb(255,255,255);
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.9) 10%, rgba(255,255,255,0.01) 100%); */
        background: rgb(255,255,255);
        background: linear-gradient(180deg, rgba(255,255,255,1) 38%, rgba(255,255,255,1) 62%, rgba(255,255,255,0) 100%); 
        top: 0;
        z-index: -1; 
        transform: translateX(-50%);
    }
    
     h4 {
        font-size: 24px;
        font-family: var(--common-font);
        margin-bottom: 25px;
        @media (max-width: 767px){
            font-size: 22px;
        }
        }    
     p {
        font-size: 17px;
        max-width: 910px;
        margin: 30px auto 20px;
        font-family: var(--common-font);
        } 
       @media (max-width: 991px){
        br {
  display: none;
}
       }
    }  

`;

export const SectionFiveCss = styled.div`
    background: ${props => `url(${props.BgImage})`};
    .fifth-top {
        background: rgb(68 107 147 / 60%);
        padding: 20px 0px;
        margin: 0 0 100px;
        @media (max-width: 991px){
            margin: 0 0 60px;
        }
           @media (max-width: 767px){
            margin: 0 0 10px;

        }
    } 

.fifth-sec {
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 1100px;
            width: 100%;
            margin: 0 auto;
            gap: 30px;
            padding: 0 15px;
            @media (max-width:767px){
                flex-direction: column;
            }
            .section_fiveText {
            max-width: calc(100% - 300px);
            flex: 100%;
            text-align: left;  
            color:  var(--cmn-white);
            font-weight:400;
            @media (max-width:767px){
                max-width: 100%;
            }
            h3 {
            font-size: 49px;
            line-height: 58px;
            font-family: var(--common-font);
            text-transform: uppercase;
            @media (max-width: 1280px){
                font-size: 38px;
                line-height: normal;
            }
            @media (max-width: 991px){
                font-size: 26px;
            }
            @media (max-width: 767px){
            font-size: 24px;
                line-height: 1.5;
                }
        }
        p{
            font-size: 19px;
            font-family: var(--common-font);  
            @media (max-width: 991px){
                font-size: 18px;
            }  
        }
    }
.section_fiveImage {
  max-width: 250px;
}
} 
`;

export const CommonDashboardStyle = createGlobalStyle`
    .last-inner-sec {
        position: relative;
        overflow: hidden;
        .section-banner iframe{
        width: 250vw;
        height: 140%;
        position: absolute;
        left: 50%; 
        top: 50%;
        transform: translate(-50% , -50%);
        z-index: -1; 
        @media (max-width: 991px){
            width: 300vw;
        }
        @media (max-width: 767px){
            width: 740vw;
        }
    }

    }
 
    .last-inner-sec div +div+button{
        margin-top: 60px;
    }
    .secondBlock_sectionOne { 
      margin: 60px auto; 
      position: relative;
       padding-bottom: 54% ;
                  iframe {
                    height: 100%;
                    position: absolute;
                    left: 50%;
                    width: 100vw;
                    top: 50%;
                    transform: translate(-50% , -50%);
                    }
        }
  
   .top-img-sec.mobile {
    display: none;
    .container {
    display: flex;
    justify-content: center;
    padding: 30px 15px;
}
 img {
    max-width: 270px;
    width: 100%;
    display: flex;
}
    @media (max-width:991px){
    display: block;
    }



}
`;
export const FirstSectionCss = styled.div`
    padding: 40px 0; 
    border-top: 2px solid #c2c2c2;
    background-image: linear-gradient(0deg, #ffffff 0%, #f0f0f0 100%);

    .cstm-row {
        align-items: flex-start;

        @media (max-width:991px){
            flex-direction: column-reverse;
            gap: 20px;
        }
        .left-sec, .right-sec {
            width:calc(100%/2);
            padding: 0 15px;

            @media only screen and (max-width: 991px) {
                width:calc(100%);
                
            }
        }

        .left-sec {
            text-align: left;
            padding-right: 40px;
            
            @media only screen and (max-width: 991px) {
                order: 2;
                text-align: center;
                padding-right: 15px;
            }

            h1 {
                max-width: 100%;
                margin-bottom: 30px;

                @media only screen and (max-width: 1399px) {
                    max-width: 100%;
                    margin-bottom: 20px;
                }

                @media only screen and (max-width: 991px) {
                    max-width: unset;
                }
            }
            
            p {
                font-size: 19px;
                line-height: 1.4;
                color: #000;

                @media only screen and (max-width: 1399px) {
                    font-size: 20px;
                }

                @media only screen and (max-width: 1199px) {
                    font-size: 17px;
                }
                @media only screen and (max-width: 991px) {
                    text-align: start;
                }
            }
            & p:nth-child(3) {
                margin: 30px 0;
                @media (max-width:767px){
                    margin: 15px 0;
                }
            }


        }

        .right-sec {
            @media only screen and (max-width: 991px) {
                order: 1;
                margin-bottom: 0px;
            }
            figure {
                margin: 0 auto;
                width: 100%;
                display: block;
                max-width: 100%;

                img {
                    width: 100%;
                }
            }
        }
    }
    p.single_div {
    margin-top: 20px;
    color: #000;
}
`
export const SecondSectionCss = styled.div`
    border-top: 2px solid #c2c2c2;
    text-align: left;
    padding: 60px 0;
    background-image: linear-gradient(0deg, #ffffff 0%, #f0f0f0 100%);

    @media only screen and (max-width: 1199px) {
        padding: 50px 0;
    }
    @media only screen and (max-width: 991px) {
        padding: 30px 0;
    }
    
    .cstm-row {
        .mobile{
            display: none !important;
        }
        .left-img-sec, .right-img-sec {
            width:calc(100%/2);
            padding: 0 15px;
            display: flex;
            flex-direction: column;
            
            @media only screen and (max-width: 991px) {
                width:calc(100%);
                gap: 0px;
                .mobile{
                    display: block !important;
                }
                .desktop{
                    display: none !important;
                }                   
            }

            figure {
                margin: 0;
                width: 100%;
                display: block;
                
                img {
                    width: 100%;
                    display: block;
                }
            }
            /* .text-content {
                display: flex;
        }
          .text-content img {
            width: 100%;
            height: auto;
            max-width: 250px;
        } */
            .text-content {
                @media only screen and (max-width: 991px) {
                    text-align: center;
                }
            }
        }

        .left-img-sec {
            @media only screen and (max-width: 991px) {
                margin-bottom: 30px;
            }
        }
        @media (max-width:991px){
            h2{
            text-align: center;
        }
        }

        .right-img-sec {
            .text-content {
                @media only screen and (max-width: 991px) {
                    order: 2;
                }
            }

            figure {
                @media only screen and (max-width: 991px) {
                    order: 1;
                }
            }
        }
    }

    .earn-commission-image {
        position: relative;
        top: 0;
        left: auto;
        height: auto;
        width: 100%;
        @media (max-width:991px){
            margin-top: 40px;
        }
        img.first_img {
            width: 100%;
            object-fit: cover;
            @media (max-width:991px){
                height: auto;
                object-position: bottom;
            }
        }
    }
      img.earn-commission {
        position: absolute;
        right: 15%;
        top: 70px;
        @media (max-width:1199px){
            right: 20px;
            top: 20px;
            max-width: 300px;
        }
        @media (max-width:991px){
            left: 50%;
            right: auto;
            transform: translateX(-50%);
            top: -40px;
            max-width: 450px;
            width: 100%;
        }
    }
    .benefits-list ul {
        list-style: unset;
    }
    .product-details {
     display: flex;
     gap: 80px;
     @media (max-width:1199px){
        flex-wrap: wrap;
     }
    }
    .product-refer {
        display: flex;
    }
    .all-product-images {
        box-shadow: 0 0 10px 0px rgb(0 0 0 / 10%);
        border-radius: 15px;
        padding: 45px;
        margin: 10px !important;
        background: #fff;
        width: 100%;
        max-width: 300px;
        min-height: 175px;
}


.cstm-row .right-img-sec .text-content {
    display: flex;
    align-items: flex-end;
    margin-bottom: 40px;
    @media (max-width:1199px){
        margin-bottom: 15px;
    }
    
}

.cstm-row .right-img-sec .text-content img {
    max-width: 197px;
}

.cstm-row .right-img-sec .text-content h2 {
    max-width: 340px;
    font-size: 52px;
    font-weight: 400;
    color: #000;
    line-height: 1;
    margin: 0;
    @media (max-width:1199px){
        font-size: 40px;
        font-weight: 300;
    }
}

.cstm-row .right-img-sec {
    padding-left: 40px !important;
    @media (max-width:991px){
        padding-left: 15px !important;
        display: none;
    }
}
.cstm-row .right-img-sec .benefits-section h5.benefits-include {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 700;
    @media (max-width:991px){
        margin-top: 10px;
        margin-bottom: 10px;
    }
}

.cstm-row .right-img-sec .benefits-section ul {
    list-style-position: inside;
    margin-bottom: 60px;
    list-style-type: none;
    @media (max-width:1199px){
        margin-bottom: 20px;
    }
}

.cstm-row .right-img-sec .benefits-section ul li {
    font-size: 22px;
    line-height: 32px;
    position: relative;
    padding-left: 20px;
    color: #000;
    @media (max-width:1199px){
        font-size: 20px;
        line-height: 30px;
    }
    @media (max-width:767px){
        font-size: 18px;
        line-height: 28px;
    }
}

.cstm-row .right-img-sec .benefits-section ul li:after {
    content: "";
    width: 8px;
    height: 8px;
    background: #000;
    position: absolute;
    left: 0;
    top: 10px;
    border-radius: 50px;
}

.cstm-row .right-img-sec .benefits-section ul li:not(:last-child) {
    margin-bottom: 20px;
    @media (max-width:1199px){
        margin-bottom: 10px;
    }
}

.cstm-row .right-img-sec .become-an-affiliate h4 {
    margin-bottom: 14px;
    font-size: 30px;
    line-height: 1.2;
    font-weight: 700;
    @media (max-width:1199px){
        font-size: 20px;
    }
    @media (max-width:991px){
        font-size: 28px;
        text-align: center;
    }
}

.cstm-row .right-img-sec .become-an-affiliate button.btn.signup {
    margin-top: 20px;
    @media (max-width:1199px){
        margin-top: 0px;
    }
    @media (max-width:991px){
        margin-inline: auto;
        display: block;
    }
}

.cstm-row .right-img-sec .become-an-affiliate p {
    font-size: 22px;
    color: #000;
    @media (max-width:1199px){
        font-size: 20px;
    }
    @media (max-width:991px){
        text-align: center;
    }
}
.demonstrate-commission {
    padding: 80px 0 0;
    p.single_div {
    margin-top: 20px;
    color: #000;
}
    .right-img-sec.mobile {
    display: none;
    @media (max-width:991px){
        display: block;
    }
}
    @media (max-width:991px){
        padding: 50px 0 0;
    }

    &.mobile{
        display: none;
        @media (max-width:991px){
            display: block;
            background-image: linear-gradient(0deg, #ffffff 0%, #f0f0f0 100%);
            border-top: 2px solid #c2c2c2;
        }
    }
    &.desktop{
        @media (max-width:991px){
            display: none;
        }
    }
    h4.h4 {
        @media (max-width:991px){
            font-size: 16px;
            font-weight: 400;
            margin-top: 50px;
        }
}
}

.demonstrate-commission h4 {
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 20px;
    @media (max-width:1199px){
        font-size: 20px;
    }
    @media (max-width:991px){
        font-size: 28px;
    }
    
}
.demonstrate-commission p{
    @media (max-width:991px){
        text-align: center;
    }
} 
.become-an-affiliate button {
    @media (max-width:991px){
        margin-inline: auto;
        display: flex;
    }

}

.demonstrate-commission .product-details {
    gap: 30px;
    flex-wrap: wrap;
    justify-content: center;
}

.demonstrate-commission .product-details .all-product-images {
    margin: 0!important;
    padding: 20px 18px;
    width: calc(100% / 4 - 23px);
    min-height: 180px;
    height: auto;
    background-image: radial-gradient(circle at center, #f8f4fc 0%, #c1d4ed 100%);
    border: 1.05950016479156px solid #a7a7a7;
    border-radius: 15px;
    @media (max-width:1199px){
        width: calc(100% / 2 - 23px);
    }
    @media (max-width:767px){
        width: 100%;
    }
}
.demonstrate-commission .product-details .all-product-images >p {
    margin-bottom: 15px;
    font-size: 18px;
    color: #000;
    font-weight: 500;
    text-align: center;
}

.demonstrate-commission .product-details .all-product-images .product-refer {
    flex-wrap: wrap;
    align-items: center;
}
.demonstrate-commission .product-details .all-product-images .product-refer .amount-sec p {
    margin-bottom: 5px;
    font-size: 18px;
    color: #000;
    font-weight: 700;
    font-style: italic;
    @media (max-width:991px){
        text-align: start;
    }
}

.demonstrate-commission .product-details .all-product-images .product-refer .amount-sec h5 {
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #0071e1;
    font-style: italic;
    @media (max-width:1399px) {
        font-size: 28px;
    }
}


.demonstrate-commission .product-details .all-product-images .product-refer img {
    max-width: 110px;
    width: 100%;
    padding-right: 8px;
}

.demonstrate-commission .product-details .all-product-images .product-refer .amount-sec {
    width: calc(100% - 110px);
}

button.signup-btnn {
    background-color: #0071e1;
    font-size: 21px;
    line-height: 2;
    letter-spacing: 2px;
    border-radius: 50px;
    color: var(--cmn-white);
    min-width: 191px;
    border: none;
    padding: 5px 33px;
    transition: all ease-in-out 0.3s;
    box-shadow: none;
    margin-top:20px;
}

`
export const ThirdSectionCss = styled.div`
background-image: linear-gradient(0deg, #ffffff 0%, #f0f0f0 100%);
    border-top: 2px solid #c2c2c2;
    padding: 60px 0;
    @media (max-width:991px){
        padding: 40px 0;
    }

    .container {
        display: flex;
        gap: 30px;
        @media (max-width:991px){
            flex-wrap: wrap;
            flex-direction: column-reverse;
    }
    
 }
  .images-section img{
    width: 100%;
  }


.third-section .first-section {
    width: 50%;
    @media (max-width:991px){
        width: 100%;
    }
    h1{
        @media (max-width:991px){
        text-align: center;
    }
    }
}

.third-section .images-section {
    width: 50%;
    @media (max-width:991px){
        width: 100%;
    }
}
.third-section .first-section .referral-urls h4 {
    font-size: 18px !important;
    font-weight: 600;
}
.third-section .first-section .referral-urls h4 ~ h4 {
    margin-top: 40px !important;
}
.third-section .images-section img {
    height: 100%;
    object-fit: cover;
}
    .third-section h1 {
    font-size: 35px;
}

`
export const FourthSectionCss = styled.div`
    text-align: center;
    padding: 40px 0 152px;
    background: linear-gradient(0deg, rgba(255,255,255,1) 50%, rgba(248,248,248,1) 100%);
    
    @media only screen and (max-width: 1399px) {
        padding: 40px 0 120px;
    }

    @media only screen and (max-width: 1199px) {
        padding: 40px 0 100px;
    }

    @media only screen and (max-width: 1199px) {
        padding: 40px 0 80px;
    }

    @media only screen and (max-width: 1199px) {
        padding: 40px 0 50px;
    }

    .col-12 {
        padding: 0 15px;
    }

    .reward-plan {
        h2 {
            margin-bottom: 24px;
        }

        p {
            max-width: 950px;
            margin-left: auto;
            margin-right: auto;
        }

        h6 {
            margin-bottom: 0px;
        }

        figure {
            margin: 50px 0 60px;

            @media only screen and (max-width: 991px) {
                margin: 30px 0 40px;
            }

            @media only screen and (max-width: 991px) {
                margin: 20px 0 30px;
            }
        }
    }
  
`